import React, { useState } from 'react';
import { Card, Typography, Button, message, Space, List, Result, Modal } from 'antd';
import {
  RocketOutlined, CheckCircleOutlined, WhatsAppOutlined, TrophyOutlined,
  BarChartOutlined, StarOutlined, ThunderboltOutlined,
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';

const { Title, Text, Paragraph } = Typography;

const BENEFITS = [
  { icon: <WhatsAppOutlined />, title: 'Convocação automática', desc: 'Envio no grupo do WhatsApp nas datas certas — early, 1ª, 2ª e 3ª chamada.' },
  { icon: <ThunderboltOutlined />, title: 'Chip dedicado anti-banimento', desc: 'Enviamos por um número exclusivo — teu WhatsApp pessoal protegido.' },
  { icon: <TrophyOutlined />, title: 'Ranking e estatísticas', desc: 'Gols, assistências, cartões, MVP automático depois de cada jogo.' },
  { icon: <StarOutlined />, title: 'Sistema de avaliação', desc: 'Jogadores avaliam uns aos outros. Prova social pro time.' },
  { icon: <BarChartOutlined />, title: 'Painel completo', desc: 'Presença, frequência, cobrança de mensalidade, controle de caixa.' },
];

export default function TeamOwnerUpgrade() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const nav = useNavigate();

  const confirm = () => {
    Modal.confirm({
      title: 'Confirma virar cliente Futezap?',
      content: 'Vai criar tua conta no admin Futezap com 30 dias de trial grátis. Depois disso é R$ 29,90/mês (Boleiro Básico).',
      okText: 'Sim, quero testar',
      cancelText: 'Ainda não',
      onOk: doUpgrade,
    });
  };

  const doUpgrade = async () => {
    setLoading(true);
    try {
      const r = await api.post(`/community/team-owner/${id}/upgrade-to-futezap`);
      setResult(r.data);
    } catch (err) {
      message.error(err.response?.data?.message || 'Erro ao converter');
    } finally { setLoading(false); }
  };

  if (result) {
    return (
      <div style={{ maxWidth: 720, margin: '20px auto', padding: 16 }}>
        <Card>
          <Result
            status="success"
            icon={<CheckCircleOutlined style={{ color: '#25D366' }} />}
            title="Bem-vindo ao Futezap!"
            subTitle={`Trial de 30 dias ativo até ${new Date(result.trial_expires_at).toLocaleDateString('pt-BR')}. Próximo passo: definir tua senha do admin.`}
            extra={[
              <Button type="primary" size="large" key="reset"
                onClick={() => nav('/login?email=' + encodeURIComponent(result.login_hint.username))}>
                Ir pro admin Futezap
              </Button>,
              <Button size="large" key="dash" onClick={() => nav(`/time/dashboard/${id}`)}>
                Voltar ao painel do time
              </Button>,
            ]}
          />
        </Card>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 720, margin: '20px auto', padding: 16 }}>
      <Card>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <RocketOutlined style={{ fontSize: 48, color: '#25D366' }} />
          <Title level={3} style={{ margin: '12px 0 4px' }}>Vira cliente Futezap</Title>
          <Text type="secondary">30 dias grátis. Sem cartão de crédito. Cancela quando quiser.</Text>
        </div>

        <Paragraph>
          Teu time <strong>já existe na comunidade</strong>. Ao virar cliente Futezap você
          desbloqueia toda a automação da operação — do convite pré-jogo até o ranking pós-jogo.
        </Paragraph>

        <List
          dataSource={BENEFITS}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                avatar={<div style={{ fontSize: 24, color: '#25D366', width: 40 }}>{item.icon}</div>}
                title={<strong>{item.title}</strong>}
                description={item.desc}
              />
            </List.Item>
          )}
        />

        <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: 16, marginTop: 16 }}>
          <Text strong>O que muda no teu time?</Text>
          <ul style={{ margin: '8px 0 0', paddingLeft: 20 }}>
            <li>Tua conta de dono do time-comunidade continua igual.</li>
            <li>Ganha acesso ao painel admin.futezap.com.br pra operar o time.</li>
            <li>O time aparece com badge "Verificado" no mapa.</li>
            <li>Após 30 dias, se quiser continuar, R$ 29,90/mês via PIX.</li>
          </ul>
        </div>

        <Space direction="vertical" style={{ width: '100%', marginTop: 20 }}>
          <Button type="primary" size="large" block icon={<RocketOutlined />}
            loading={loading} onClick={confirm}>
            Ativar trial de 30 dias grátis
          </Button>
          <Button block onClick={() => nav(`/time/dashboard/${id}`)}>
            Ainda não, obrigado
          </Button>
        </Space>
      </Card>
    </div>
  );
}
